import { SearchParams } from '@/types/common'
import {
  Controller,
  CreateController,
  CreateOperationsRain,
  RunManualStation,
  SearchController,
  UpdateController,
  UpdateMultipleController,
} from '@/types/controller'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const controllerDataConfigApi = {
  getAll(searchParams: SearchController) {
    const url = `/api/Controller/${searchParams.interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getMk2Template(interfaceId: number) {
    const url = `api/setup/${interfaceId}/import/download-mk2-decoder`
    return axiosClient.get(url, {
      responseType: 'blob',
    })
  },

  uploadMk2DecoderFile(interfaceId: number, data: FormData) {
    const url = `api/setup/${interfaceId}/import/upload-mk2-decoder`
    return axiosClient.post<any>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  getDecoderType(searchParams: SearchParams = {}) {
    const url = `/api/Controller/${searchParams.interfaceId}/decoder-type`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getWaterTankTopValve(searchParams: SearchParams = {}) {
    const url = `/api/WaterTank/${searchParams.interfaceId}/valves`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  // getIOConfig(searchParams: SearchIOConfig) {
  //   const url = `/api/ioconfig`
  //   return axiosClient.get(url + queryStringify(searchParams))
  // },

  getIOConfig(
    interfaceId: number,
    address: number,
    type: number,
    twiId?: number,
  ) {
    var url = `/api/ioconfig/get-by-decoder?interfaceId=${interfaceId}&address=${address}&type=${type}`
    url += twiId ? `&twiId=${twiId}` : ''
    return axiosClient.get(url)
  },

  getIOConfiguration(interfaceId: number) {
    const url = `/api/ioconfig/get-by-multiple-decoders?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  // Every configuration for the interface. Already scoped by interface and
  // already excluding blank/invalid descriptions server-side. PageSize=0
  // means "all".
  getIOConfigList(interfaceId: number) {
    const url = `/api/ioconfig?interfaceId=${interfaceId}&PageSize=0`
    return axiosClient.get(url)
  },

  // Line units, keyed by decoder address, carrying the line unit type id.
  getLineUnits(interfaceId: number) {
    const url = `/api/lineunit?interfaceId=${interfaceId}&PageSize=0`
    return axiosClient.get(url)
  },

  // Line unit types hold the protocol. This endpoint takes no interfaceId, so
  // it returns every interface's types and callers filter client-side.
  getLineUnitTypes() {
    const url = `/api/lineunittype?PageSize=0`
    return axiosClient.get(url)
  },

  // A control hub's sub-controllers, each a separate interface. Its own line
  // units live on these subs, not on the hub interface, so the protocol map
  // has to read line units from each sub. Returns [] for a plain controller.
  getSubInterfaces(interfaceId: number) {
    const url = `/api/interface/${interfaceId}/subs`
    return axiosClient.get(url)
  },

  getIOConfigDecoder(interfaceId: number, address: number, type: number) {
    const url = `/api/ioconfig/getbydecoder?interfaceId=${interfaceId}&address=${address}&type=${type}`
    return axiosClient.get(url)
  },

  getIODetail(interfaceId: number) {
    const url = `/api/Controller/${interfaceId}/get-details-input`
    return axiosClient.get(url)
  },

  getAutoSyncDecoder(interfaceId: number) {
    const url = `/api/autosyncdata/manual-src-objectsync-io?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getById(interfaceId: string, id: string) {
    var url = `/api/Controller/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateController) {
    const url = `/api/Controller/${payload.interfaceId}`
    return axiosClient.post(url, payload, {
      timeout: 30000,
    })
  },

  createRainOperation(payload: CreateOperationsRain) {
    const url = '/api/waterengine/rain-operation'
    return axiosClient.patch(url, payload)
  },

  runManualStation(payload: RunManualStation) {
    const url = '/api/station/manual-run'
    return axiosClient.post(url, payload)
  },

  getStationOn(payload: any) {
    const interfaceId = payload.interfaceId
    const id = payload.id
    const url = `/api/station/on?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.get(url)
  },

  getStationOff(payload: any) {
    const interfaceId = payload.interfaceId
    const id = payload.id
    const url = `/api/station/off?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.get(url)
  },

  getUsage(interfaceId: number, id: string) {
    const url = `/api/Controller/${interfaceId}/${id}/usage`
    return axiosClient.get(url)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/Controller/${interfaceId}/${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateController) {
    const url = `/api/Controller/${payload.interfaceId}/${payload.id}`
    return axiosClient.put(url, payload)
  },

  updateConfiguration(payload: UpdateMultipleController) {
    const url = `/api/Controller/${payload.interfaceId}/apply-cfg-multiple`
    return axiosClient.put(url, payload)
  },
  getdetailforstationbyordinal(interfaceId: number, id: number) {
    const url = `/api/Controller/${interfaceId}/get-detail-for-station/${id}`
    return axiosClient.get<Controller>(url)
  },

  runManualWithTimeStation(payload: RunManualStation) {
    const url = '/api/station/manual-run-with-time'
    return axiosClient.post(url, payload)
  },
}

export default controllerDataConfigApi
